import React from "react";
import { useLocation } from "react-router-dom";

import Alert from "../../components/Alert";
import SearchBar from "../../components/SearchBar";

const NotFound = () => {
  const location = useLocation();
  const message = location.state?.error
    ? location.state.error
    : "No booking information could be found for the message selected. Please search on Airbase.";

  return (
    <div className="AppHeader">
      <SearchBar />
      <Alert title="Not Found..." message={message} />
    </div>
  );
};

export default NotFound;
